import InMemoryStorage from './in-memory-storage/InMemoryStorage';

const inMemoryStorage = new InMemoryStorage();

const isLocalStorageAvailable = () => {
  const key = 'isLocalStorageAvailableTest';
  try {
    localStorage.setItem(key, 'test');
    localStorage.removeItem(key);
    return true;
  } catch {
    return false;
  }
};

export function getLocalStorageContext(group: string) {
  const getKeyFor = (key: string) => `${group}/${key}`;

  if (isLocalStorageAvailable())
    return {
      isAvailable: true,
      getValue: (key: string) => localStorage?.getItem?.(getKeyFor(key)),
      setValue: (key: string, value: string) => localStorage?.setItem?.(getKeyFor(key), value),
      removeValue: (key: string) => localStorage?.removeItem?.(getKeyFor(key)),
    };
  return {
    isAvailable: false,
    getValue: (key: string) => inMemoryStorage.getItem(getKeyFor(key)),
    setValue: (key: string, value: string) => inMemoryStorage.setItem(getKeyFor(key), value),
    removeValue: (key: string) => inMemoryStorage.removeItem(getKeyFor(key)),
  };
}
